new Vue({
    el:'.worldCup',
    data(){
        return{
            // 加载完成
            loadFlag:false,
            // 发送验证码标识--------后续保留一个
            sendFlag:false,
            loginFlag:false,
            voteFlag:false,
            verifyFlag:false,
            shareFlag:false,
            // 弹窗显示标识
            popup:false,
            logPopup:false,
            addressPopup:false,
            infoPopup:false,
            loginPopup:false,
            votePopup:false,
            verifyPopup:false,
            sharePopup:false,
            qrCodePopup:false,
            isSend:false,
            isLogin:false,
            sendText:'Send code',
            findText:'',
            user:{
                name:'',
                email:'',
                code:'',
                ranking:0,
                country:'Country'
            },
            address:{
                state:'',
                city:'',
                street:'',
                postal:'',
                phone:'',
                prize:''
            },
            verify_code:'',
            submitFlag:false,
            popup1:false,
            select_flag1:0,
            countryArr:[],
            isSelect:false,
            teamData:[],
            selectIndex:-1,
            voteId:-1,
            share_link:'',
            gamePage:false,
            gameId:-1,
            downloadId:1,
            ranking:[],
            prizeArr:['World Cup Limited Gift Box','Football Crossbody Bag','Water Bottle'],
            voteInfo:[], //活动一球队奖池信息
            prizeNum:[
                {
                    "id": 1,
                    "name": "World Cup Limited Gift Box",
                    "count": 25
                },
                {
                    "id": 2,
                    "name": "Football Crossbody Bag",
                    "count": 30
                },
                {
                    "id": 3,
                    "name": "Water Bottle",
                    "count": 30
                }
            ],
            box5Swiper1:null,
            // 轮播时间条
            timeData:[
                {time:'06 / 29',info:'Ongoing'},
                {time:'06 / 30',info:'Upcoming'},
                {time:'07 / 01',info:'Upcoming'},
                {time:'07 / 02',info:'Upcoming'},
                {time:'07 / 03',info:'Upcoming'},
                {time:'07 / 04',info:'Upcoming'},
                {time:'07 / 05',info:'Upcoming'},
                {time:'07 / 06',info:'Upcoming'},
                {time:'07 / 07',info:'Upcoming'},
                {time:'07 / 08',info:'Upcoming'},
                {time:'07 / 10',info:'Upcoming'},
                {time:'07 / 11',info:'Upcoming'},
                {time:'07 / 12',info:'Upcoming'},
                {time:'07 / 15',info:'Upcoming'},
                {time:'07 / 16',info:'Upcoming'},
                {time:'07 / 19',info:'Upcoming'},
                {time:'07 / 20',info:'Upcoming'}
            ],
            // vote 是否投票 fail 该国家是否失败  update review-----------------------------
            allData:[
                [
                    [{day:'06-29',vote:false,fail:false,name:'South Africa',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/53ba435650382f78b71166f5461f4555.avif?v=1782468082'},
                    {day:'06-29',vote:false,fail:false,name:'Canada',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/7c6ebb904602c3446eb932cbb272dfe3.avif?v=1782468081'}]
                ],
                [
                    [{day:'06-30',vote:false,fail:false,name:'Brazil',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/e1875f0f39a11970ee512ee30378daed.avif?v=1782468082'},
                    {day:'06-30',vote:false,fail:false,name:'Japan',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/a99625a5069e455078812699912c99ec.avif?v=1782468081'}],
                    [{day:'06-30',vote:false,fail:false,name:'Germany',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/44482fbe0b70d3a5812c141b049de7cd.avif?v=1782469303'},
                    {day:'06-30',vote:false,fail:false,name:'Paraguay',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/895968d0045c52fa5b347df6e194b774.avif?v=1782636768'}],
                    [{day:'06-30',vote:false,fail:false,name:'Netherlands',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/d0ea50413e9ea6e28879a805634ad7fc.avif?v=1782469303'},
                    {day:'06-30',vote:false,fail:false,name:'Morocco',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/88a4ae5d8eb8b00323cab1a8c710b5f1.avif?v=1782469303'}]
                ],
                [
                    [{day:'07-01',vote:false,fail:false,name:'Ivory Coast',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/ded1b3eb787d7fc3ed448f7f13a64d70.avif?v=1782696089'},
                    {day:'07-01',vote:false,fail:false,name:'Norway',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/fa94ab06679f1a79a358d033851d02f6.avif?v=1782696088'}],
                    [{day:'07-01',vote:false,fail:false,name:'France',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/7f4f125e737f52034f6cc131f38796ac.avif?v=1782696088'},
                    {day:'07-01',vote:false,fail:false,name:'Sweden',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/607797f8264f9492d10a38b50673563e.avif?v=1782696088'}],
                    [{day:'07-01',vote:false,fail:false,name:'Mexico',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/73667f20d8ec7d224ab317e5a47c87ef.avif?v=1782696089'},
                    {day:'07-01',vote:false,fail:false,name:'Ecuador',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/fde679b47abda74a4820a0c11294568d.avif?v=1782696089'}]
                ],
                [
                    [{day:'07-02',vote:false,fail:false,name:'England',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/15f8b200dcdde6b4ab74482f286fb44d.avif?v=1782697474'},
                    {day:'07-02',vote:false,fail:false,name:'DR Congo',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/78b41f4f656180b9858a4ee666d7b507.avif?v=1782697473'}],
                    [{day:'07-02',vote:false,fail:false,name:'Belgium',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/f4b7e8494f056740e9e338a9a3984d41.avif?v=1782697473'},
                    {day:'07-02',vote:false,fail:false,name:'Senegal',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/a41362eb173d157360e9fff38d800613.avif?v=1782697474'}],
                    [{day:'07-02',vote:false,fail:false,name:'United States',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/ffb21c494c38cb722c9331de53cda10e.avif?v=1782697474'},
                    {day:'07-02',vote:false,fail:false,name:'Bosnia and Herzegovina',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/8e122c90d185d55e6b1e7057fe407980.avif?v=1782697473'}]
                ],
                [
                    [{day:'07-03',vote:false,fail:false,name:'Spain',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/79360b8c5a06af33c9fd4d257490d5d1.avif?v=1782698028'},
                    {day:'07-03',vote:false,fail:false,name:'Austria',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/e097396b0f82338e9c437cc6bf25f17f.avif?v=1782698028'}],
                    [{day:'07-03',vote:false,fail:false,name:'Portugal',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/2b663b421a81570ffaad66581ef6bf50.avif?v=1782698028'},
                    {day:'07-03',vote:false,fail:false,name:'Croatia',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/b6e45346114243dbb05ce6bf1156d945.avif?v=1782698028'}],
                    [{day:'07-03',vote:false,fail:false,name:'Switzerland',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/2efbe827ef0d0c922e4603a222a16cb6.avif?v=1782698028'},
                    {day:'07-03',vote:false,fail:false,name:'Algeria',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/58c5d34826bf03d0f0aaca05064300b0.avif?v=1782698028'}]
                ],
                [
                    [{day:'07-04',vote:false,fail:false,name:'Australia',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/dd965127705141f6c9cb19f1070a2367.avif?v=1782698190'},
                    {day:'07-04',vote:false,fail:false,name:'Egypt',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/6c1bc1f8212224b6a9038558053d4ea2.avif?v=1782698190'}],
                    [{day:'07-04',vote:false,fail:false,name:'Argentina',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/1d4476cc103b8419dc63db57a558fe0d.avif?v=1782698190'},
                    {day:'07-04',vote:false,fail:false,name:'Cape Verde',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/04d11a7907372323e17d61101f6ae80b.avif?v=1782698190'}],
                    [{day:'07-04',vote:false,fail:false,name:'Colombia',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/44abff2d31b622a529b9e80b6982ffe4.avif?v=1782698190'},
                    {day:'07-04',vote:false,fail:false,name:'Ghana',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/825fa89fde7a7599fd9c1ede7408c8b8.avif?v=1782698190'}]
                ],
                [
                    [{day:'07-05',vote:false,fail:false,name:'Canada',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/7c6ebb904602c3446eb932cbb272dfe3.avif?v=1782468081'},
                    {day:'07-05',vote:false,fail:false,name:'Morocco',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/88a4ae5d8eb8b00323cab1a8c710b5f1.avif?v=1782469303'}],
                    [{day:'07-05',vote:false,fail:false,name:'Paraguay',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/895968d0045c52fa5b347df6e194b774.avif?v=1782636768'},
                    {day:'07-05',vote:false,fail:false,name:'France',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/7f4f125e737f52034f6cc131f38796ac.avif?v=1782696088'}]
                ],
                [
                    [{day:'07-06',vote:false,fail:false,name:'Brazil',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/e1875f0f39a11970ee512ee30378daed.avif?v=1782468082'},
                    {day:'07-06',vote:false,fail:false,name:'Norway',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/fa94ab06679f1a79a358d033851d02f6.avif?v=1782696088'}],
                    [{day:'07-06',vote:false,fail:false,name:'Mexico',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/73667f20d8ec7d224ab317e5a47c87ef.avif?v=1782696089'},
                    {day:'07-06',vote:false,fail:false,name:'England',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/15f8b200dcdde6b4ab74482f286fb44d.avif?v=1782697474'}]
                ],
                [
                    [{day:'07-07',vote:false,fail:false,name:'Portugal',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/2b663b421a81570ffaad66581ef6bf50.avif?v=1782698028'},
                    {day:'07-07',vote:false,fail:false,name:'Spain',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/79360b8c5a06af33c9fd4d257490d5d1.avif?v=1782698028'}],
                    [{day:'07-07',vote:false,fail:false,name:'United States',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/ffb21c494c38cb722c9331de53cda10e.avif?v=1782697474'},
                    {day:'07-07',vote:false,fail:false,name:'Belgium',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/f4b7e8494f056740e9e338a9a3984d41.avif?v=1782697473'}]
                ],
                [
                    [{day:'07-08',vote:false,fail:false,name:'Argentina',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/1d4476cc103b8419dc63db57a558fe0d.avif?v=1782698190'},
                    {day:'07-08',vote:false,fail:false,name:'Egypt',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/6c1bc1f8212224b6a9038558053d4ea2.avif?v=1782698190'}],
                    [{day:'07-08',vote:false,fail:false,name:'Switzerland',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/2efbe827ef0d0c922e4603a222a16cb6.avif?v=1782698028'},
                    {day:'07-08',vote:false,fail:false,name:'Colombia',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/44abff2d31b622a529b9e80b6982ffe4.avif?v=1782698190'}]
                ],
                [
                    [{day:'07-10',vote:false,fail:false,name:'France',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/7f4f125e737f52034f6cc131f38796ac.avif?v=1782696088'},
                    {day:'07-10',vote:false,fail:false,name:'Morocco',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/88a4ae5d8eb8b00323cab1a8c710b5f1.avif?v=1782469303'}]
                ],
                [
                    [{day:'07-11',vote:false,fail:false,name:'Spain',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/79360b8c5a06af33c9fd4d257490d5d1.avif?v=1782698028'},
                    {day:'07-11',vote:false,fail:false,name:'Belgium',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/f4b7e8494f056740e9e338a9a3984d41.avif?v=1782697473'}]
                ],
                [
                    [{day:'07-12',vote:false,fail:false,name:'Norway',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/fa94ab06679f1a79a358d033851d02f6.avif?v=1782696088'},
                    {day:'07-12',vote:false,fail:false,name:'England',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/15f8b200dcdde6b4ab74482f286fb44d.avif?v=1782697474'}],
                    [{day:'07-12',vote:false,fail:false,name:'Argentina',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/1d4476cc103b8419dc63db57a558fe0d.avif?v=1782698190'},
                    {day:'07-12',vote:false,fail:false,name:'Switzerland',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/2efbe827ef0d0c922e4603a222a16cb6.avif?v=1782698028'}]
                ],
                [ 
                    [{day:'07-15',vote:false,fail:false,name:'France',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/7f4f125e737f52034f6cc131f38796ac.avif?v=1782696088'},
                    {day:'07-15',vote:false,fail:false,name:'Spain',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/79360b8c5a06af33c9fd4d257490d5d1.avif?v=1782698028'}]
                ],
                [
                    [{day:'07-16',vote:false,fail:false,name:'England',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/15f8b200dcdde6b4ab74482f286fb44d.avif?v=1782697474'},
                    {day:'07-16',vote:false,fail:false,name:'Argentina',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/1d4476cc103b8419dc63db57a558fe0d.avif?v=1782698190'}]
                ],
                [
                    [{day:'07-19',vote:false,fail:false,name:'France',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/7f4f125e737f52034f6cc131f38796ac.avif?v=1782696088'},
                    {day:'07-19',vote:false,fail:false,name:'England',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/15f8b200dcdde6b4ab74482f286fb44d.avif?v=1782697474'}]
                ],
                [
                    [{day:'07-20',vote:false,fail:false,name:'Spain',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/79360b8c5a06af33c9fd4d257490d5d1.avif?v=1782698028'},
                    {day:'07-20',vote:false,fail:false,name:'Argentina',img:'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/1d4476cc103b8419dc63db57a558fe0d.avif?v=1782698190'}]
                ]
            ],
            // 日期
            timeIndex:0, 
            //可投票日期
            voteIndex:0,
            // 场次
            numIndex:0,
            //选择国家
            countryFlag:-1,
            voteRankArr:[],
            ShareImgArr:[
                'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/cd7d3dc73fa710dee4a0455e2e8d4782.jpg?v=1778811240',
                'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/053b317c3c23ee1af1d273dae38dfadc.jpg?v=1778811240',
                'https://cdn.shopify.com/s/files/1/0584/6709/0582/files/8c8dce5950071e37f8872c44dc5ededd.avif?v=1782470904',
            ],
            typeId:0
        }
    },
    methods:{
        // 功能类-------------------------------------------------
        async submitAddress(){
            if(!this.address.state || !this.address.city || !this.address.street || !this.address.postal || !this.address.phone){
                showMessage('Please fill in the information completely','error')
                return;
            } 

            showMessage('Submitting, please wait...','success')
            //避免重复提交 
            if(this.submitFlag) return;
            this.submitFlag = true
            this.address.name = this.user.name
            this.address.email = this.user.email
            this.address.country = this.user.country

            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.address));
            let res = await axios.post('https://service.oxvatech.cn/wordCup/submitAddress',params, {
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                showMessage('Submission successful, preparing for shipment.','success')
                this.getInfo()
            }else{
                let errorMessages = {
                    201: 'Ops, This badge is not available.',
                    202: 'Ops, Rewards are sold out.',
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
            this.popup = this.addressPopup = this.submitFlag = false
        },
        async Voting(){
            if(this.selectIndex==-1) return;
            if(this.user.vote==0){
                return showMessage('No voting rights yet','error')
            }

            showMessage('Voting is in progress, please wait...','success')
            if(this.voteFlag) return; //避免重复提交
            this.voteFlag = true

            let params=new URLSearchParams();
            params.append('info',JSON.stringify({id:this.voteId,team:this.teamData[this.voteId-1].team}));
            let res = await axios.post('https://service.oxvatech.cn/wordCup/vote',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status==200){
                showMessage('Voting successful!','success')
                this.user.vote -= 1
                this.teamData[this.voteId-1].bonus += 2
                this.teamData[this.voteId-1].num += 1
            }else{ 
                let errorMessages = {
                    201:'No voting rights yet',
                    500:'Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
            this.voteFlag = false

        },
        async verifyCode(){
            if(this.verify_code == ''){
                showMessage('please fill in the anti-counterfeiting code first.','error');
                return;
            }

            showMessage("Verification in progress...",'success')
            //避免重复提交 
            if(this.verifyFlag) return;
            this.verifyFlag = true

            let params=new URLSearchParams();
            params.append('info',JSON.stringify({verify_code:this.verify_code}));
            let res = await axios.post('https://service.oxvatech.cn/wordCup/verifyCode',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                this.user.vote += 1;
                this.popup = this.verifyPopup = false
                showMessage("Verification successful",'success')
            }else{
                let errorMessages = {
                    201: 'Anti-counterfeiting code does not exist.',
                    202: 'The anti-counterfeiting code has been verified.',
                    // 203: 'The anti-counterfeiting code has been verified multiple times.',
                    500:' Server error, please contact customer service.',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
            this.verifyFlag = false
        },
        async shareImg(){
            if(this.share_link == ''){
                return showMessage('Please enter the sharing link first','error');
            }

            try{
                const url = new URL(this.share_link)

                // 只允许 http / https
                if(!['http:', 'https:'].includes(url.protocol)) return 
            }catch (e) {
                return showMessage('Please enter the correct link format','error');
            }

            //避免重复提交 
            if(this.shareFlag) return;
            this.shareFlag = true

            let params=new URLSearchParams();
            params.append('info',JSON.stringify({share_link:this.share_link,id:this.downloadId}));
            let res = await axios.post('https://service.oxvatech.cn/wordCup/shareImg',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                showMessage("Submission successful, awaiting review...",'success')
            }else{
                let errorMessages = {
                    201: "You've already submitted today. Take a break!",
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
            this.popup = this.verifyPopup = this.shareFlag = false
        },
        async sendEmail(){
            if(this.user.email == ''){
                showMessage('Please enter your email','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            if(this.sendFlag){
                showMessage('Sent, please try again in one minute.','success')
                setTimeout(() => {
                    this.sendFlag = false
                    this.sendText = 'Send code'
                }, 1000*60);
                return;
            }
            this.sendText = 'Has sent'
            this.sendFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/wordCup/sendEmail',params);
            if(res.data.status == 200){
                this.isSend = true
                showMessage('Email has been sent, please check.','success')
            }else{
                showMessage('Server error, please contact customer service','error')
            }
        },
        async loginActivity(){
            if(!this.isSend){
                showMessage('Please send the email verification code first','error')
                return;
            }
            if(!this.user.name || !this.user.email || this.user.country == 'Country' || !this.user.code){
                showMessage('Please fill in the information completely','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            //避免重复提交
            if(this.loginFlag) return;
            this.loginFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/wordCup/loginActivity',params);
            if(res.data.status == 200){
                this.setCookie('_oxbar_word_cup_',res.data.data,70)
                this.user.token = res.data.data
                showMessage('Good luck! ','success')
                this.popup = this.loginPopup = false
                this.getInfo()
            }else{
                this.loginFlag = false
                let errorMessages = {
                    201: 'Email verification code error',
                    202: 'Username already exists',
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
        },
        async getInfo(){
            let res = await axios.post('https://service.oxvatech.cn/wordCup/getInfo', {}, {
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                if(res.data.data.info.length>0){
                    this.isLogin = true
                    this.user = res.data.data.info[0]

                    this.voteInfo = res.data.data.vote
                    if(this.user.name == ''){
                        //this.nav_index=3
                    } 

                    //历史投票信息
                    if(this.user.voteArr.length>0){
                        this.user.voteArr = JSON.parse(this.user.voteArr)
                        //更新页面显示
                        for(let item of this.user.voteArr){
                            // 使用 split 方法分割字符串
                            let parts = item.day.split('-');
                            // 将字符串转换为整数
                            let month = parseInt(parts[0], 10);
                            let day = parseInt(parts[1], 10);
                            //获取日期下标
                            var num = this.turnTime(month,day)
                            for(let x=1;x<5;x++){
                                //判断场次是否存在
                                if(item.hasOwnProperty(x)){
                                    //循环国家判断是否已投票
                                    for(let i=0;i<this.allData[num][x-1].length;i++){
                                        if(item[x] == this.allData[num][x-1][i].name){
                                            //更新投票显示
                                            this.allData[num][x-1][i].vote = true
                                        }
                                    }
                                }
                            }
                        }
                        
                    }else{
                        this.user.voteArr = []
                    }

                }else{
                    this.isLogin = false
                }
            }else{
                showMessage('server error','error')
            }
        },
        //获取比赛信息 更新失败显示
        async getVoteInfo(){
            let res = await axios.get('https://service.oxvatech.cn/wordCup/getVoteInfo');
            if(res.data.status == 200){
                let arr = res.data.data
                for(let i of arr){
                    // 使用 split 方法分割字符串
                    let parts = i.day.split('-');
                    // 将字符串转换为整数
                    let month = parseInt(parts[0], 10);
                    let day = parseInt(parts[1], 10);
                    //获取日期下标
                    var num = this.turnTime(month,day)
                    let num1 = Number(i.round)-1
                    let num2 = Number(i.winner)-1
                    if(num2 == 0){
                        this.allData[num][num1][1].fail = true
                    }else if(num2 ==1){
                        this.allData[num][num1][0].fail = true
                    }
                }
            }
        },
        async getData(){
            let res = await axios.get('https://service.oxvatech.cn/public/getAllCountry')
            if(res.status == 200){
                this.countryArr = res.data.data
            }

            let res2 = await axios.get('https://service.oxvatech.cn/wordCup/getTeams')
            if(res2.status == 200){
                this.teamData = res2.data.data.vote
                this.prizeNum = res2.data.data.prize
            }
        },
        async getRanking(){
            let res = await axios.get('https://service.oxvatech.cn/wordCup/getRanking')
            if(res.status == 200){
                this.ranking = res.data.data
            }
        },
        async getVoteRanking(){
            let res = await axios.get('https://service.oxvatech.cn/wordCup/getVoteRanking')
            if(res.status == 200){
                this.voteRankArr = res.data.data
            }
        },
        async scoreLog(score,num){
            let params=new URLSearchParams();
            params.append('info',JSON.stringify({points:score,num:num}));
            let res = await axios.post('https://service.oxvatech.cn/wordCup/step',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status==200){
                this.gameId = res.data.data.gameId
            }else{
                showMessage("Server error, please contact customer service",'error')
            }
        },
        async startGame(){
            if(this.user.chance>0){
                let res = await axios.post('https://service.oxvatech.cn/wordCup/start',{},{
                    headers: { Authorization: `${this.user.token}`}
                });
                if(res.data.status==200){
                    this.user.chance -= 1
                }else{
                    showMessage("There's no chance, go share it now",'error')
                }
            }else{
                showMessage("There's no chance, go share it now",'error')
            }
        },
        // 点击投票
        voteNow(){
            if(!this.checkLogin()) return;
            if(this.timeData[this.timeIndex].info == 'Upcoming'){
                return showMessage('Voting time has not yet arrived','error')
            }
            if(this.timeData[this.timeIndex].info == 'Ended'){
                return showMessage('Voting has ended','error')
            }
            // Ongoing
            if(this.countryFlag == -1){
                return showMessage('Please select a country first','error')
            }
            //组合当前投票信息
            var nowDay = this.allData[this.timeIndex][this.numIndex][this.countryFlag].day
            var nowName = this.allData[this.timeIndex][this.numIndex][this.countryFlag].name
            var nowRound = this.numIndex+1, isVot = true, that = this

            if(this.user.voteArr.length>0){
                for(let i of this.user.voteArr){
                    //判断该天是否已投票
                    if(i.day == nowDay){
                        isVot = false
                        if(i.hasOwnProperty(nowRound)){
                            //同一场再次投票
                            showMessage('You have voted for this round','error')
                        }else{
                            //同一天其他场次投票
                            i[nowRound] = nowName
                            this.sendVote()
                        }
                    }
                }
                if(isVot){
                    //该天未投票
                    voteing()
                }
            }else{
                //第一次投票
                voteing()
            }

            function voteing(){
                let obj = {day:nowDay}
                obj[nowRound] = nowName
                that.user.voteArr.push(obj)
                that.sendVote()
            }
        },
        // 发送投票信息
        async sendVote(){
            let nowName = this.allData[this.timeIndex][this.numIndex][this.countryFlag].name
            showMessage(`Thank you for voting for ${nowName}`,'success');

            let info = {
                day:this.allData[this.timeIndex][this.numIndex][this.countryFlag].day,
                round:this.numIndex+1,
                country:this.countryFlag+1,
                vote:this.user.voteArr,
                id:this.user.id
            }
            if(this.voteFlag) return; //避免重复提交
            this.voteFlag = true

            var params=new URLSearchParams();
            params.append('info',JSON.stringify(info));
            let res = await axios.post('https://service.oxvatech.cn/wordCup/cupVote',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                //更新
                this.allData[this.timeIndex][this.numIndex][this.countryFlag].vote = true
            }
            this.voteFlag = false
        },
        // 控件类-------------------------------------------------
        switchBout(index){
            this.numIndex = index
            this.countryFlag = -1
        },
        endGame(){
            // 更新数据
            this.getInfo()
            this.getRanking()
        },
        toRedeem(id){
            this.address.prize = this.prizeArr[id-1]
            this.address.prizeId = id
            this.infoPopup=false;
            this.addressPopup=true;
        },
        toShare(id){
            if(!this.checkLogin()) return;
            this.downloadId = id
            this.share_link = ''
            this.popup = this.sharePopup = true
        },
        toShareP(id){
            this.downloadId = id
            this.share_link = ''
            this.infoPopup=false;
            this.sharePopup = true
        },
        playGame(){
            if(!this.checkLogin()) return;
            if(this.user.chance>0){
                this.gamePage = true
                setTimeout(() => {
                    this.initGame()
                }, 100);
            }else{
                return showMessage('Oops, no chance, go share it now','error')
            }
        },
        selectTeam(index){
            if(this.selectIndex==index){
                this.selectIndex=-1
            }else{
                this.selectIndex=index
            }
            this.voteId = this.teamData[index].id
        },
        showPopup(type){
            if(!this.checkLogin()) return;
            this.popup = this[type] = true;
        },
        checkLogin(){
            if(!this.isLogin){
                this.popup = this.loginPopup = true;
                return false;
            }
            return true;
        },
        endTips(){
            showMessage('The event has ended, thank you for your participation.','success')
        },
        emailUpdate(){
            if(this.isSend){
                this.isSend = false
                this.sendFlag = false
                this.sendText = 'Send code'
            }
        },
        // 工具类-------------------------------------------------
        turnTime(month,day){
            // 转成数字方便比较
            const inputValue = month * 100 + day;

            // 不在 6/29 ~ 7/20 区间，直接返回0
            if (inputValue < 629) {
                return -1;
            }
            if (inputValue > 720) {
                return 16;
            }

            // 遍历找到 <= 当前日期 的最大下标
            let resultIndex = 0;

            this.timeData.forEach((item, index) => {
                const [m, d] = item.time.split('/').map(v => parseInt(v.trim()));
                const itemValue = m * 100 + d;

                if (itemValue <= inputValue) {
                    resultIndex = index;
                }
            });

            return resultIndex;
        },
        //获取当前日期
        getDataNum(){
            // 获取北京时间（东八区）
            var currentDate = new Date(
                new Date().toLocaleString("en-US", { timeZone: "Asia/Shanghai" })
            );
            
            // 提取北京时间的月份和日期
            var month = currentDate.getMonth() + 1; // getMonth() 返回的月份是 0-11，因此加 1
            var day = currentDate.getDate();
            month = 7
            day = 19;

            //投票后一天的比赛
            this.timeIndex = this.voteIndex = this.turnTime(month,day)+1

            //更新可投票日期
            for(let i=0;i<this.timeData.length;i++){
                if(i == this.voteIndex){
                    this.timeData[i].info = 'Ongoing'
                }else if(i < this.voteIndex){
                    this.timeData[i].info = 'Ended'
                }else{
                    this.timeData[i].info = 'Upcoming'
                }
            }
        },
        formatISOToDateTime(isoString) {
            var date = new Date(isoString);
          
            // 转为北京时间（+8小时）
            date.setHours(date.getHours());
          
            var pad = (n) => n.toString().padStart(2, '0');
            var year = date.getFullYear();
            var month = pad(date.getMonth() + 1);
            var day = pad(date.getDate());
            var hours = pad(date.getHours());
            var minutes = pad(date.getMinutes());
            var seconds = pad(date.getSeconds());
          
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        downloadImg(){
            var imageUrl = this.ShareImgArr[this.downloadId-1]

            axios.get(imageUrl, {
                responseType: 'blob' // 返回的是 Blob 格式
            }).then(response => {
                const blob = new Blob([response.data], { type: 'image/jpg' }); // 指定 MIME 类型
                const url = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;
                link.download = 'OXBAR-PLAY-FULL-ON.jpg'; // 设置下载文件名
                document.body.appendChild(link);
                link.click();
                
                showMessage('The image has been downloaded, go share it','success')
                
                // 清理
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }).catch(error => {
                console.error('error:', error);
                showMessage(
                    'Download failed',
                    'error'
                );
            });
        },
        // 扫描二维码识别数字
        qrCode(){
            var that = this
            this.verifyPopup = false
            this.qrCodePopup = true
            setTimeout(() => {
                let html5QrCode = new Html5Qrcode("qr-reader");
                html5QrCode.start(
                    { facingMode: "environment" }, // 后置摄像头
                    {
                        fps: 10,
                        qrbox: 250,
                    },
                    (decodedText) => {
                        // 停止扫描
                        html5QrCode.stop().then(() => {
                        });

                        // 提取数字
                        const numbers = decodedText.match(/\d+/g);
                        that.verify_code = numbers.join(", ")
                        that.qrCodePopup = false
                        that.verifyPopup = true
                    }
                ).catch(err => {
                    this.popup = this.qrCodePopup = false
                    showMessage('Camera access failed', 'error');
                });
            }, 300);
        },
        QuickFind(){
            var countryList = this.$refs.countryList; // 获取 .country_option 元素
            // 找到第一个以输入字母开头的国家元素
            var targetCountry = Array.from(countryList.children).find((country) =>
                country.textContent.trim().toLowerCase().startsWith(this.findText.toLowerCase())
            );

            if (targetCountry) {
                // 滚动到目标国家
                targetCountry.scrollIntoView({ block: 'start' });
            }
        },
        // cookie
        setCookie(name,value,day){
            var d = new Date();
            d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },
        getCookie(name){
            var name = name + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for(let i = 0; i < cookieArray.length; i++) {
                let cookie = cookieArray[i];
                while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                return cookie.substring(name.length, cookie.length);
                }
            }
            return "";
        },
        initGame(){
            var that = this
            // 使用 jQuery 获取页面元素；Canvas 实例本身仍需取出原生 DOM 才能拿到 2D 上下文
            const $canvas = $('#game');
            const canvas = $canvas[0];
            const ctx = canvas.getContext('2d');
            
            // HUD / 文案 / 弹层 / 按钮：统一使用 jQuery 对象，便于 text() / addClass() / on() 等操作
            const $scoreValue = $('#scoreValue');
            const $shotsValue = $('#shotsValue');
            const $bestValue = $('#bestValue');
            const $timerValue = $('#timerValue');
            const $tip = $('#tip');
            
            const $startOverlay = $('#startOverlay');
            const $endOverlay = $('#endOverlay');
            const $startBtn = $('#startBtn');
            const $restartBtn = $('#restartBtn');
            const $endTitle = $('#endTitle');
            const $endText = $('#endText');
            
            let dpr = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
            let W = 0;
            let H = 0;
            
            let finishGame;
            let resolveShot;
            
            // 游戏全局状态：分数、回合、倒计时、连击、结果文案等
            const state = {
                running: false,
                score: 0,
                shotsLeft: 7,
                bestScore: that.user.points,
                dragging: false,
                aimStart: null,
                aimCurrent: null,
                goalFlash: 0,
                particles: [],
                keeperDir: 1,
                lastTime: 0,
                combo: 0,
                level: 1,
                wind: 0,
                roundIndex: 0,
                targetDir: 1,
                resultText: '',
                resultTimer: 0,
                shotTimeLimit: 15,
                shotClock: 15,
                shotResolved: false,
                shotTimerStarted: false,
            };
            
            // 足球对象：控制位置、半径、飞行状态、目标点、力度等
            const ball = {
                x: 0, y: 0, r: 18,
                shadowScale: 1,
                active: false,
                flying: false,
                startX: 0, startY: 0,
                targetX: 0, targetY: 0,
                lineCrossX: 0,
                peakY: 0,
                t: 0,
                speed: 1.05,
                scored: false,
                power: 0,
                goalConfirmed: false,
            };
            
            // 球门对象：控制位置、尺寸、球网密度，以及判定进球的“球门线”
            const goal = {
                x: 0, y: 0, w: 0, h: 0,
                netCols: 10, netRows: 5,
                lineY: 0,
            };
            
            // 守门员对象：控制位置、体积、移动速度、扑救偏移
            const keeper = {
                x: 0, y: 0, w: 90, h: 40,
                speed: 220,
                dive: 0,
            };
            
            const targetZone = {
                x: 0, y: 0, w: 46, h: 34,
            };
            
            // 重新计算画布尺寸、球门位置、守门员位置等；
            // 注意：绘图仍使用原生 Canvas API，jQuery 主要负责 DOM 与事件层
            function resize() {
                dpr = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
                W = window.innerWidth;
                H = window.innerHeight;
                
                canvas.width = Math.floor(W * dpr);
                canvas.height = Math.floor(H * dpr);
                canvas.style.width = W + 'px';
                canvas.style.height = H + 'px';
                ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
                
                goal.w = Math.min(W * 0.56, 340);
                goal.h = Math.min(H * 0.12, 92);
                goal.x = (W - goal.w) / 2;
                goal.y = Math.max(68, H * 0.14);
                // 进球判定线：位于球门前方一点的位置，球越过它且没碰到守门员即算进球
                goal.lineY = goal.y + goal.h + Math.max(10, H * 0.01);
                
                keeper.w = goal.w * 0.26;
                keeper.h = goal.h * 0.54;
                // 守门员站位前移一些：更靠近玩家这一侧
                keeper.y = goal.y + goal.h * 0.72;
                keeper.x = W / 2 - keeper.w / 2;
                
                targetZone.w = Math.max(40, goal.w * 0.14);
                targetZone.h = Math.max(28, goal.h * 0.34);
                
                resetBall();
                randomizeRound(true);
            }
            
            function randomizeRound(first = false) {
                state.roundIndex++;
                state.level = Math.min(5, 1 + Math.floor((7 - state.shotsLeft + (first ? 0 : 1)) / 2));
                state.wind = 0;
                // 根据当前第几球递增速度
                const shotIndex = (7 - state.shotsLeft + 1);
                keeper.speed = 180 + shotIndex * 70;
                keeper.dive = 8 + state.level * 3;
                
                const sidePadding = 10;
                const minX = goal.x + sidePadding;
                const maxX = goal.x + goal.w - targetZone.w - sidePadding;
                const minY = goal.y + 8;
                const maxY = goal.y + goal.h - targetZone.h - 6;
                
                targetZone.x = minX + Math.random() * (maxX - minX);
                targetZone.y = minY + Math.random() * (maxY - minY);
                state.targetDir = Math.random() > 0.5 ? 1 : -1;
            }
            
            function resetBall() {
                ball.r = Math.max(15, Math.min(22, W * 0.04));
                ball.x = W / 2;
                ball.y = H * 0.83;
                ball.startX = ball.x;
                ball.startY = ball.y;
                ball.active = true;
                ball.flying = false;
                ball.t = 0;
                ball.speed = 1.05;
                ball.scored = false;
                ball.power = 0;
                ball.goalConfirmed = false;
                state.dragging = false;
                state.aimStart = null;
                state.aimCurrent = null;
                state.shotClock = state.shotTimeLimit;
                state.shotResolved = false;
                state.shotTimerStarted = false;
            }
            
            // 刷新顶部 HUD 显示
            function updateHud() {
                $scoreValue.text(state.score);
                $shotsValue.text(state.shotsLeft);
                $bestValue.text(state.bestScore);
                // 非逐帧场景下默认按整数显示；逐帧倒计时会在 update() 中实时覆盖
                $timerValue.text(Math.max(0, Math.ceil(state.shotClock)));
            }
            
            // 处理“超时未射门”或“本球超时失败”
            function failShotByTimeout() {
                if (!state.running || state.shotResolved) return;
                
                state.shotResolved = true;
                state.combo = 0;
                state.resultText = 'No shot taken before time expired';
                state.resultTimer = 1.5;
                state.shotsLeft -= 1;
                updateHud();
                
                // 停止当前拖拽/射门状态
                state.dragging = false;
                state.aimStart = null;
                state.aimCurrent = null;
                ball.flying = false;
                ball.active = false;
                
                createBurst(ball.x, ball.y, 10, '255,120,120');
                $tip.text('Timeout, this ball is ruled invalid.');
                
                setTimeout(() => {
                    if (state.shotsLeft <= 0) {
                        finishGame();
                    } else {
                        randomizeRound();
                        resetBall();
                        $tip.text(`Preparing Ball ${8 - state.shotsLeft} | You have 15 seconds to complete it after dragging starts`);
                        updateHud();
                    }
                }, 1500);
            }
            
            // 重置整局游戏数据
            function resetGame() {
                state.score = 0;
                state.shotsLeft = 7;
                state.goalFlash = 0;
                state.particles = [];
                state.running = true;
                state.combo = 0;
                state.resultText = '';
                state.resultTimer = 0;
                state.shotClock = state.shotTimeLimit;
                state.shotResolved = false;
                keeper.x = W / 2 - keeper.w / 2;
                state.keeperDir = Math.random() > 0.5 ? 1 : -1;
                randomizeRound(true);
                updateHud();
                resetBall();
                $tip.text('Drag to shoot. 15s limit. Combo goals for bonus points.');
            }
            
            function beginGame() {
                // 开始游戏
                that.startGame()
                $startOverlay.addClass('hidden');
                $endOverlay.addClass('hidden');
                resetGame();
            }
            
            function createBurst(x, y, count = 12, color = '255,216,77') {
                for (let i = 0; i < count; i++) {
                    const angle = Math.random() * Math.PI * 2;
                    const speed = 70 + Math.random() * 170;
                    state.particles.push({
                        x, y,
                        vx: Math.cos(angle) * speed,
                        vy: Math.sin(angle) * speed,
                        life: 0.7 + Math.random() * 0.45,
                        age: 0,
                        size: 2 + Math.random() * 4,
                        color,
                    });
                }
            }
            
            // 根据用户拖拽位移发起射门
            function shootBall(dx, dy) {
                if (!state.running || !ball.active || ball.flying) return;
                
                // 计算拖拽总距离，过短则不触发射门
                const distance = Math.hypot(dx, dy);
                
                // 只允许“向前拖动”（向上拖动）才能射门
                // dy > 0 表示向下拖（往后），直接无效
                if (distance < 26 || dy > 0) {
                    state.dragging = false;
                    state.aimStart = null;
                    state.aimCurrent = null;
                    return;
                }
                
                // 将拖拽距离映射成 0~1 的力度值
                const maxPull = Math.min(H * 0.34, 230);
                const clamped = Math.min(distance, maxPull);
                const power = clamped / maxPull;
                
                const nx = dx / distance;
                const ny = dy / distance;
                
                // 完全按手势直线飞：
                // 以拖拽方向向前延长，和“球门线”所在高度相交的位置作为最终判定点。
                // 只要足球越过这条线，并且过程中没有碰到守门员，就算进球成功。
                const gateLineY = goal.lineY;
                
                // 用球门线来计算方向（保证判定正确）
                const scaleToGateLineY = (gateLineY - ball.y) / dy;
                const rawTargetX = ball.x + dx * scaleToGateLineY;
                
                // 记录足球穿过“不可见球门线”时的横向位置，供进球判定使用
                ball.lineCrossX = Math.min(goal.x + goal.w - 16, Math.max(goal.x + 16, rawTargetX));
                
                // 视觉落点仍然在球网内部（更真实）
                const goalCenterY = goal.y + goal.h * 0.6;
                
                ball.targetX = ball.lineCrossX;
                ball.targetY = goalCenterY;
                ball.peakY = Math.min(ball.startY - 250 * power, H * 0.24);
                ball.flying = true;
                ball.t = 0;
                ball.speed = 0.3 + power * 1.35;
                ball.scored = false;
                ball.power = power;
                
                state.dragging = false;
                state.aimStart = null;
                state.aimCurrent = null;
                $tip.text(`Shot on goal...`);
            }
            
            function getPoint(e) {
                const p = e.touches ? e.touches[0] : e;
                return { x: p.clientX, y: p.clientY };
            }
            
            function canDragAt(x, y) {
                return Math.hypot(x - ball.x, y - ball.y) <= ball.r + 18;
            }
            
            // 用户开始按下：只有点到足球时才进入拖拽瞄准状态
            function handleDown(e) {
                if (!state.running || !ball.active || ball.flying) return;
                const p = getPoint(e);
                if (canDragAt(p.x, p.y)) {
                    state.dragging = true;
                    state.aimStart = { x: ball.x, y: ball.y };
                    state.aimCurrent = { x: p.x, y: p.y };
                    
                    // 倒计时从“用户开始拖动这一球”时才开始
                    if (!state.shotTimerStarted) {
                        state.shotTimerStarted = true;
                        state.shotClock = state.shotTimeLimit;
                        $timerValue.text(Math.max(0, Math.ceil(state.shotClock)));
                    }
                    
                    $tip.text('Continue dragging upwards to shoot');
                }
            }
            
            // 用户拖拽过程中，实时更新当前指针位置
            // 这里直接禁止向下拖动：当前指针 y 不能超过起始点 y
            function handleMove(e) {
                if (!state.dragging) return;
                const p = getPoint(e);
                
                // 禁止向下拖动，只允许保持原位或向上拖
                const clampedY = Math.min(p.y, state.aimStart.y);
                
                state.aimCurrent = { x: p.x, y: clampedY };
            }
            
            // 用户松手时，根据起点与终点的位移正式射门
            function handleUp() {
                if (!state.dragging || !state.aimCurrent || !state.aimStart) return;
                const dx = state.aimCurrent.x - state.aimStart.x;
                const dy = state.aimCurrent.y - state.aimStart.y;
                shootBall(dx, dy);
            }
            
            // 每一帧更新：守门员移动、足球飞行、粒子、倒计时等
            function update(dt) {
                if (!state.running) return;
                
                // 本球倒计时：从“用户开始拖动这一球”后才开始流逝
                if (!state.shotResolved && state.shotTimerStarted) {
                    state.shotClock = Math.max(0, state.shotClock - dt);
                    // 实时刷新倒计时显示（整秒跳动）
                    $timerValue.text(Math.max(0, Math.ceil(state.shotClock)));
                    if (state.shotClock <= 0) {
                        failShotByTimeout();
                        return;
                    }
                } else {
                    // 尚未开始拖动时，固定显示完整秒数；出结果后显示剩余秒数
                    $timerValue.text(Math.max(0, Math.ceil(state.shotClock)));
                }
                
                const minX = goal.x;
                const maxX = goal.x + goal.w - keeper.w;
                
                // 守门员随机移动：方向、停顿、速度微变化都不固定
                if (Math.random() < 0.018 + state.level * 0.004) {
                    state.keeperDir = Math.random() > 0.5 ? 1 : -1;
                }
                if (Math.random() < 0.008) {
                    state.keeperDir = 0;
                }
                if (state.keeperDir === 0 && Math.random() < 0.06) {
                    state.keeperDir = Math.random() > 0.5 ? 1 : -1;
                }
                
                const keeperStep = keeper.speed * (0.8 + Math.random() * 1.2) * dt;
                keeper.x += state.keeperDir * keeperStep;
                
                if (keeper.x <= minX) {
                    keeper.x = minX;
                    state.keeperDir = Math.random() < 0.75 ? 1 : 0;
                } else if (keeper.x >= maxX) {
                    keeper.x = maxX;
                    state.keeperDir = Math.random() < 0.75 ? -1 : 0;
                }
                
                
                
                if (ball.flying) {
                    ball.t += dt * ball.speed;
                    const t = Math.min(ball.t, 1);
                    const ease = 1 - Math.pow(1 - t, 3);
                    
                    // 完全按手势直线飞：x/y 都沿起点到终点的直线插值，
                    // 不再叠加抛物线弧度，避免视觉上偏离白色虚线方向。
                    ball.x = ball.startX + (ball.targetX - ball.startX) * ease;
                    ball.y = ball.startY + (ball.targetY - ball.startY) * ease;
                    ball.shadowScale = 1 - 0.58 * ease;
                    
                    const keeperReactionBoost = state.level >= 3 ? Math.sin(t * Math.PI) * keeper.dive : 0;
                    const reactiveKeeperX = keeper.x + (ball.targetX > keeper.x + keeper.w / 2 ? keeperReactionBoost : -keeperReactionBoost);
                    
                    // 只有在“还没有越过红线确认进球”之前，守门员才有机会扑到球。
                    if (!ball.goalConfirmed) {
                        const hitX = ball.x >= reactiveKeeperX && ball.x <= reactiveKeeperX + keeper.w;
                        const hitY = ball.y >= keeper.y - 16 && ball.y <= keeper.y + keeper.h + 12;
                        if (hitX && hitY) {
                            ball.scored = true;
                            ball.flying = false;
                            ball.active = false;
                            resolveShot(false, 'Saved by the goalkeeper', '255,120,120');
                            return;
                        }
                        
                        // 只要足球越过红线，并且在此之前没有碰到守门员，就立即确认本球成功。
                        // 但先不结算，让球继续飞进球网内部，保持视觉表现完整。
                        if (ball.y <= goal.lineY) {
                            ball.goalConfirmed = true;
                            //$tip.text('GOAL! 已越过红线，足球继续飞入球网');
                        }
                    }
                    
                    // 飞到最终落点后再正式结算：
                    // 已越线则成功，否则算射偏。
                    if (t >= 1 && !ball.scored) {
                        ball.scored = true;
                        ball.flying = false;
                        ball.active = false;
                        
                        if (ball.goalConfirmed) {
                            resolveShot(true, 'GOAL!', '255,216,77');
                        } else {
                            resolveShot(false, 'Shot off target', '255,120,120');
                        }
                        return;
                    }
                }
                
                state.goalFlash = Math.max(0, state.goalFlash - dt * 2.2);
                state.resultTimer = Math.max(0, state.resultTimer - dt);
                
                state.particles = state.particles.filter((p) => {
                    p.age += dt;
                    p.x += p.vx * dt;
                    p.y += p.vy * dt;
                    p.vy += 185 * dt;
                    return p.age < p.life;
                });
            }
            
            // 处理本球结果：进球 / 扑救 / 射偏
            resolveShot = function(success, text, particleColor = '255,216,77') {
                if (state.shotResolved) return;
                state.shotResolved = true;

                const currentShot = 8 - state.shotsLeft;
                let gained = 0;
                if (success) {
                    const inTarget =
                    ball.targetX >= targetZone.x &&
                    ball.targetX <= targetZone.x + targetZone.w &&
                    ball.targetY >= targetZone.y &&
                    ball.targetY <= targetZone.y + targetZone.h;
                    
                    // 死角判定：根据球穿过球门线的位置（lineCrossX）
                    const cornerBonus = (
                    ball.lineCrossX < goal.x + 42 ||
                    ball.lineCrossX > goal.x + goal.w - 42
                    );
                    
                    // 基础进球得分
                    gained = 10;
                    if (ball.power > 0.75) gained += 3;
                    if (inTarget) gained += 8;
                    if (cornerBonus) gained += 5;
                    
                    state.combo += 1;
                    if (state.combo >= 2) gained += Math.min(10, (state.combo - 1) * 2);
                    
                    state.score += gained;
                    state.goalFlash = 1;
                    createBurst(ball.x, ball.y, 20, particleColor);
                    $tip.text(`${text} +${gained} points| batter x${state.combo}`);
                    state.resultText = inTarget ? 'Perfect hit!' : (cornerBonus ? 'Top corner finish!' : 'Beautiful goal!');
                } else {
                    state.combo = 0;
                    createBurst(ball.x, ball.y, 10, particleColor);
                    $tip.text(text);
                    state.resultText = text;
                }
                // step
                that.scoreLog(gained,currentShot)
                
                state.resultTimer = 1.5;
                state.shotsLeft -= 1;
                updateHud();
                
                ball.flying = false;
                ball.active = false;
                
                setTimeout(() => {
                    if (state.shotsLeft <= 0) {
                        finishGame();
                    } else {
                        randomizeRound();
                        resetBall();
                        $tip.text(`Preparing Ball ${8 - state.shotsLeft} | You have 15 seconds to complete it after dragging starts`);
                        updateHud();
                    }
                }, 1500);
            };
            
            finishGame = function() {
                state.running = false;
                // 历史总分 本局得分
                state.bestScore += state.score;
                // 结束游戏 
                that.endGame()
                updateHud();
                $endTitle.text(state.score >= 90 ? 'Masterful performance!' : state.score >= 60 ? 'Very impressive!' : 'GAME OVER');
                $endText.text(`This game's score is ${state.score} points, and the total score is ${state.bestScore} points`);
                $endOverlay.removeClass('hidden');
            };
            
            // 绘制草地背景、场地线、闪光效果
            function drawPitch() {
                ctx.clearRect(0, 0, W, H);
                
                const stripeH = H / 8;
                for (let i = 0; i < 8; i++) {
                    ctx.fillStyle = i % 2 === 0 ? 'rgba(255,255,255,.04)' : 'rgba(0,0,0,.03)';
                    ctx.fillRect(0, i * stripeH, W, stripeH);
                }
                
                ctx.strokeStyle = 'rgba(255,255,255,.35)';
                ctx.lineWidth = 2;
                ctx.beginPath();
                ctx.arc(W / 2, H * 0.68, Math.min(90, W * 0.18), 0, Math.PI, true);
                ctx.stroke();
                
                ctx.beginPath();
                ctx.arc(W / 2, H * 0.68, 3, 0, Math.PI * 2);
                ctx.fillStyle = 'rgba(255,255,255,.7)';
                ctx.fill();
                
                if (state.goalFlash > 0) {
                    ctx.fillStyle = `rgba(255,216,77,${0.18 * state.goalFlash})`;
                    ctx.fillRect(0, 0, W, H);
                }
            }
            
            // 绘制球门与球网（进球判定线仅用于逻辑，不在画面中显示）
            function drawGoal() {
                ctx.save();
                
                ctx.fillStyle = '#efefef';
                ctx.fillRect(goal.x - 6, goal.y - 6, 6, goal.h + 18);
                ctx.fillRect(goal.x + goal.w, goal.y - 6, 6, goal.h + 18);
                ctx.fillRect(goal.x - 6, goal.y - 6, goal.w + 12, 6);
                
                ctx.fillStyle = 'rgba(220,235,255,.18)';
                ctx.fillRect(goal.x, goal.y, goal.w, goal.h);
                
                ctx.strokeStyle = 'rgba(255,255,255,.35)';
                ctx.lineWidth = 1;
                
                for (let i = 1; i < goal.netCols; i++) {
                    const x = goal.x + (goal.w / goal.netCols) * i;
                    ctx.beginPath();
                    ctx.moveTo(x, goal.y);
                    ctx.lineTo(x, goal.y + goal.h);
                    ctx.stroke();
                }
                
                for (let i = 1; i < goal.netRows; i++) {
                    const y = goal.y + (goal.h / goal.netRows) * i;
                    ctx.beginPath();
                    ctx.moveTo(goal.x, y);
                    ctx.lineTo(goal.x + goal.w, y);
                    ctx.stroke();
                }
                
                ctx.restore();
            }
            
            // 绘制守门员
            function drawKeeper() {
                const x = keeper.x;
                const y = keeper.y;
                const w = keeper.w;
                const h = keeper.h;
                
                ctx.save();
                ctx.fillStyle = '#1c2738';
                roundRectPath(x, y + h * 0.25, w, h * 0.75, 12);
                ctx.fill();
                
                ctx.fillStyle = '#ffb347';
                ctx.beginPath();
                ctx.arc(x + w * 0.5, y + h * 0.18, h * 0.26, 0, Math.PI * 2);
                ctx.fill();
                
                ctx.strokeStyle = '#ffd86b';
                ctx.lineWidth = 6;
                ctx.lineCap = 'round';
                
                ctx.beginPath();
                ctx.moveTo(x + w * 0.18, y + h * 0.45);
                ctx.lineTo(x + w * 0.82, y + h * 0.45);
                ctx.stroke();
                
                ctx.beginPath();
                ctx.moveTo(x + w * 0.24, y + h * 0.95);
                ctx.lineTo(x + w * 0.4, y + h * 1.18);
                ctx.moveTo(x + w * 0.76, y + h * 0.95);
                ctx.lineTo(x + w * 0.6, y + h * 1.18);
                ctx.stroke();
                
                ctx.restore();
            }
            
            function roundRectPath(x, y, width, height, radius) {
                ctx.beginPath();
                ctx.moveTo(x + radius, y);
                ctx.lineTo(x + width - radius, y);
                ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
                ctx.lineTo(x + width, y + height - radius);
                ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
                ctx.lineTo(x + radius, y + height);
                ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
                ctx.lineTo(x, y + radius);
                ctx.quadraticCurveTo(x, y, x + radius, y);
                ctx.closePath();
            }
            
            // 绘制足球与地面阴影
            function drawBall(x, y, r) {
                ctx.save();
                
                ctx.fillStyle = 'rgba(0,0,0,.18)';
                ctx.beginPath();
                ctx.ellipse(ball.startX, ball.startY + r * 1.7, r * 1.1 * (ball.shadowScale || 1), r * 0.48 * (ball.shadowScale || 1), 0, 0, Math.PI * 2);
                ctx.fill();
                
                ctx.translate(x, y);
                
                ctx.beginPath();
                ctx.arc(0, 0, r, 0, Math.PI * 2);
                ctx.fillStyle = '#fff';
                ctx.fill();
                ctx.lineWidth = 1.5;
                ctx.strokeStyle = 'rgba(0,0,0,.08)';
                ctx.stroke();
                
                ctx.fillStyle = '#111';
                polygon(0, 0, r * 0.34, 5);
                ctx.fill();
                
                const spots = [[-0.52,-0.18],[0.48,-0.18],[-0.3,0.45],[0.3,0.45],[0,-0.62]];
                for (const [sx, sy] of spots) {
                    polygon(r * sx, r * sy, r * 0.16, 5);
                    ctx.fill();
                }
                
                ctx.restore();
            }
            
            function polygon(cx, cy, radius, sides) {
                ctx.beginPath();
                for (let i = 0; i < sides; i++) {
                    const a = -Math.PI / 2 + (Math.PI * 2 * i) / sides;
                    const px = cx + Math.cos(a) * radius;
                    const py = cy + Math.sin(a) * radius;
                    if (i === 0) ctx.moveTo(px, py);
                    else ctx.lineTo(px, py);
                }
                ctx.closePath();
            }
            
            // 绘制白色虚线：作为“拉动蓄力”的反向提示线
            function drawAimGuide() {
                if (!state.dragging || !state.aimStart || !state.aimCurrent) return;
                const dx = state.aimCurrent.x - state.aimStart.x;
                const dy = state.aimCurrent.y - state.aimStart.y;
                const len = Math.min(Math.hypot(dx, dy), 160);
                
                ctx.save();
                ctx.setLineDash([8, 8]);
                ctx.strokeStyle = 'rgba(255,255,255,.82)';
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(ball.x, ball.y);
                ctx.lineTo(ball.x - dx * 0.55, ball.y - dy * 0.55);
                ctx.stroke();
                ctx.restore();
                
                const power = Math.round((len / 160) * 100);
                $tip.text(`Strength ${power}% | Release the shot`);
            }
            
            // 绘制粒子特效
            function drawParticles() {
                for (const p of state.particles) {
                    const alpha = 1 - p.age / p.life;
                    ctx.fillStyle = `rgba(${p.color},${alpha})`;
                    ctx.beginPath();
                    ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
                    ctx.fill();
                }
            }
            
            // 在中间显示本球结果文案
            function drawResultText() {
                if (state.resultTimer <= 0) return;
                ctx.save();
                ctx.textAlign = 'center';
                ctx.font = window.innerWidth>750?'700 34px sans-serif':'700 24px sans-serif';
                ctx.fillStyle = `rgba(255,255,255,${Math.min(1, state.resultTimer + 0.1)})`;
                ctx.fillText(state.resultText, W / 2, H * 0.42);
                ctx.font = window.innerWidth>750?'600 18px sans-serif':'600 16px sans-serif';
                ctx.fillText(`batter x${state.combo} | Difficulty Lv.${state.level}`, W / 2, H * 0.47);
                ctx.restore();
            }
            
            // 每一帧统一渲染画面
            function render() {
                drawPitch();
                drawGoal();
                drawKeeper();
                drawParticles();
                
                if (ball.active || ball.flying) {
                    const scale = ball.flying ? (1 - 0.55 * Math.min(ball.t, 1)) : 1;
                    drawBall(ball.x, ball.y, ball.r * scale);
                }
                
                drawAimGuide();
                drawResultText();
            }
            
            // 主循环：requestAnimationFrame 驱动更新与渲染
            function loop(ts) {
                const dt = Math.min(0.033, (ts - state.lastTime) / 1000 || 0.016);
                state.lastTime = ts;
                update(dt);
                render();
                requestAnimationFrame(loop);
            }
            
            // 绑定按钮事件
            // 改为 jQuery 的 on() 写法，方便后续统一维护
            $startBtn.on('click', beginGame);
            $restartBtn.on('click', beginGame);
            
            // 鼠标事件
            $canvas.on('mousedown', handleDown);
            $canvas.on('mousemove', handleMove);
            $(window).on('mouseup', handleUp);
            
            // 触摸事件：仍然阻止默认行为，避免页面滚动干扰游戏操作
            $canvas.on('touchstart', (e) => { e.preventDefault(); handleDown(e.originalEvent); });
            $canvas.on('touchmove', (e) => { e.preventDefault(); handleMove(e.originalEvent); });
            $(window).on('touchend', () => { handleUp(); });
            
            // 窗口尺寸变化时，重新计算布局
            $(window).on('resize', resize);
            
            resize();
            updateHud();
            requestAnimationFrame(loop);
        }
    },
    created(){
        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true
        //判断登录状态
        if(this.getCookie('_oxbar_word_cup_')){
            this.isLogin = true
            this.user.token = this.getCookie('_oxbar_word_cup_')
            //获取用户信息
            this.getInfo()
        }
        this.getData()
        this.getRanking()

        const params = new URLSearchParams(window.location.search);
        const id = params.get('id');

        if(id==1 || id==2 || id==3){
            this.typeId = id
        }

        //提前加载国旗图片
        var allImg = []
        for(let i of this.allData){
            for(let x of i){
                for(let y of x){
                    allImg.push(y.img)
                }
            }
        }
        const preloadImages = () => {
            for(let z of allImg){
                const img = new Image();
                img.src = z;
            }
        };
        preloadImages()

        //获取比赛信息
        this.getVoteInfo()
        this.getVoteRanking()
        // 根据当天时间 更新轮播显示
        this.getDataNum()
    },
    mounted(){
        function showUp(dom){
            gsap.from(dom,{
                y:'2rem',opacity:0,ease:'none',duration:0.5,
                scrollTrigger:{
                    trigger:dom,
                    start:'top bottom-=20%',
                    end:'+=0',
                    //toggleActions:'play none none reverse',
                }
            })
        }
        
        var wFlag=window.innerWidth>750

        $('.box3_rule').click(function(){
            $('.box3_rp').fadeIn()
        })
        $('.rp_close').click(function(){
            $(this).parent('.rulePopue').fadeOut()
        })


        if(this.typeId==0){
            showUp('.box2_title')
            if(wFlag){
                ScrollTrigger.create({
                    trigger:'.box2',
                    start:'top center-=10%',
                    end:'+=0%',
                    //toggleActions:'play none none reverse',
                    // markers:true,
                    animation:gsap.timeline()
                        .from('.box2_item',{opacity:0,y:'2rem',stagger:0.2})
                })
            }else{
                new Swiper('.box2Swiper', {
                    autoplay: true,
                    slidesPerView: 1.25,
                    centeredSlides: true,
                })
            }
        }
        
        if(this.typeId==1){
            //showUp('.box3_title')
            ScrollTrigger.create({
                trigger:'.box3',
                start:wFlag?'top top':'top top+=20%',
                end:'+=0%',
                //toggleActions:'play none none reverse',
                onUpdate:(self)=>{
                    let index = Math.floor(self.progress * 10);
                    //$('.box3_icon').toggleClass('scale1',index>2)
                    if(index>2){
                        $('.box3_icon').addClass('scale1')
                    }
                }
            })
        }
        
        if(this.typeId==2){
            showUp('.box4_title')
            ScrollTrigger.create({
                trigger:'.box4',
                start:wFlag?'top top':'top top+=20%',
                end:'+=0%',
                //toggleActions:'play none none reverse',
                onUpdate:(self)=>{
                    let index = Math.floor(self.progress * 10);
                    //$('.box4_icon').toggleClass('scale1',index>2)
                    if(index>2){
                        $('.box4_icon').addClass('scale1')
                    }
                }
            })
            if(!wFlag){
                 new Swiper('.box4Swiper', {
                    autoplay: true,
                    pagination: {
                        el: '.box4Swiper-pagination',
                    },
                })
            }
        }
         
        if(this.typeId==3){
            //showUp('.box5_title')
            new Swiper('.box5Swiper', {
                autoplay: true,
                slidesPerView: wFlag?3:1,
                centeredSlides: true,
                pagination: {
                    el: '.box5Swiper-pagination',
                },
            })
            var that = this
            this.box5Swiper1 = new Swiper('.box5Swiper1', {
                // allowTouchMove: false,
                slidesPerView:3,
                slideToClickedSlide: true,
                centeredSlides:true,
                on:{
                    slideChangeTransitionEnd:function(){
                        that.timeIndex = this.activeIndex
                        that.numIndex = 0
                        that.countryFlag = -1
                    },
                },
            })
            this.box5Swiper1.activeIndex = this.timeIndex
            this.box5Swiper1.update()
        }
    }
}) 